import Login from '@/pages/Login.vue'
import Localization from '@/pages/Localization'
import { dashboardRedirect, langGuardLocal } from '@/router/guards/lang.guard'
import { useGeneralStore } from '@/stores/general'
import { useCompanyStore } from '@/stores/company'
import Verify2FA from '@/pages/Verify2FA'

const Navigation = () => import('@/components/header-components/Navigation')

export default [
  {
    path: '/',
    redirect: dashboardRedirect
  },
  {
    /* Intentionally component-less: globalBeforeEachGuard matches on the name,
       stores the token from the query and redirects, so this never renders. */
    path: '/enter',
    name: 'enter'
  },
  {
    path: '/register/:code',
    redirect: to => {
      const generalStore = useGeneralStore()
      const companyStore = useCompanyStore()
      return {
        ...companyStore.baseRouteConfig,
        name: 'register',
        params: {
          language: generalStore.currentLocale,
          code: to.params.code
        }
      }
    }
  },
  {
    path: '/:language',
    name: 'localization',
    component: Localization,
    subnav: Navigation,
    redirect: langGuardLocal,
    children: [
      { path: 'login', name: 'login', component: Login },
      { path: '2fa', name: '2fa', component: Verify2FA },
      { path: 'register/:code', name: 'register', component: () => import('@/pages/RegisterPage.vue') },
      { path: 'reset-password', name: 'reset-password', component: () => import('@/pages/ResetPassword.vue') },
      { path: 'select-company', name: 'select-company', component: () => import('@/pages/SelectCompany.vue') },
      { path: 'profile', name: 'profile', component: () => import('@/pages/ProfilePage.vue') },
      {
        path: 'dashboard',
        name: 'dashboard',
        components: {
          default: () => import('@/pages/Dashboard.vue'),
          subnav: Navigation
        }
      },
      {
        path: 'dashboard/:offeringId/:accountId',
        name: 'offerReport',
        component: () => import('@/pages/OfferReport.vue')
      },
      {
        path: 'statements',
        name: 'statements',
        components: {
          default: () => import('@/pages/StatementsPage.vue'),
          subnav: Navigation
        }
      },
      {
        path: 'documents',
        name: 'documents',
        components: {
          default: () => import('@/pages/Documents.vue'),
          subnav: Navigation
        }
      },
      {
        path: 'ee-sign',
        name: 'ee-sign',
        components: {
          default: () => import('@/pages/ESigned.vue'),
          subnav: Navigation
        }
      },
      {
        path: 'insights',
        name: 'insights',
        components: {
          default: () => import('@/pages/Documents.vue'),
          subnav: Navigation
        }
      },
      {
        path: 'KYC',
        name: 'KYC',
        components: {
          default: () => import('@/pages/KYC.vue'),
          subnav: Navigation
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: dashboardRedirect
  }
]
